import React, { Component, Fragment } from 'react';
import axios from 'axios'

import { ValidatorForm, TextValidator, SelectValidator } from 'react-material-ui-form-validator';
import withStyles from '@mui/styles/withStyles';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { InputAdornment, TextField } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';

import styles from "../styles";
import PageHeader from "../helper/PageHeader";

import Error from '../helper/Error';
import Box from '@mui/material/Box';

import DeleteDialog from '../helper/Dialogs';

import SortedTable from '../helper/SortedTable';


const classCredit = 15;

class Employer extends Component {
    constructor(props) {
        super(props);

        this.editContacts = this.props.match.path.includes("contacts");
        console.log("editContacts: " + this.editContacts);
        this.manageTrainee = this.props.match.path.includes("trainee");
        console.log("manageTrainee: " + this.manageTrainee);

        this.token = sessionStorage.getItem('accessToken');
        this.username = JSON.parse(sessionStorage.getItem("user")).username;

        // custom rule for amount must be >= 1
        // if (!ValidatorForm.hasValidationRule('isAtLeast1')) {
        //     ValidatorForm.addValidationRule('isAtLeast1', (value) => (value < 1) ? false : true);
        // }

        this.state = {
            loading: false,
            credit: 0,
            groupName: '',
            groupType: 'Employer',
            groupCity: '',
            groupAddress: '',
            groupState: '',
            groupZipcode: '',
            email: '',
            users: [],
            info: null,
            error: null,
            selectedUser: undefined,
            trainees: [],
            contacts: [],
            groupContact: undefined,
            groupID: this.props.match.params.id,
            username: this.props.match.params.username,
            locID: undefined,
            isDeleteDialogOpen: false,
            isDeleteTraineeDialogOpen: false,
            itemToDelete: '',
            traineeToDelete: '',
            
            firstName: '',
            lastName: '',
            dob: null,
            supervisorLastName: '',

            groupStates: [],
            purchasingCredit: false,
            ipayApiData: {},
            ipayNumClasses: 1,
            ipayClassError: false,

            groupNameChecked: false
        }
    }


    handleDeleteTraineeDialogOpen = () => {
        this.setState({ isDeleteTraineeDialogOpen: true });
    };

    handleDeleteTraineeDialogClose = () => {
        this.setState({ isDeleteTraineeDialogOpen: false });
    };

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleSelectChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }


    validate = (event) => {
        let addForm = document.querySelector("#form");
        addForm.reportValidity();
        if (addForm.checkValidity() === false) {
            return false;
        }
        return true;
    }

    hideInfo = () => {
        this.setState({ info: '' })
    }

    onAdd = (event) => {
        var data = {
            username: this.state.username,
            groupName: this.state.groupName,
            groupType: this.state.groupType,
            groupAddress: this.state.groupAddress,
            groupCity: this.state.groupCity,
            groupState: this.state.groupState,
            groupZipcode: this.state.groupZipcode,
        }
        // console.log("data:", data);
        axios('/api/usergroup', {
            method: 'POST',
            data: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (response.status >= 400) {
                throw new Error(response.statusText);
            }
            this.setState({
                groupModel: false
            });
            this.props.history.goBack();
        }).catch(err => {
            this.setState({ error: err.message });
        });
    }

    onUpdate = (event) => {
        var data = {
            groupName: this.state.groupName,
            groupType: this.state.groupType,
            locID: this.state.locID,
            groupAddress: this.state.groupAddress,
            groupCity: this.state.groupCity,
            groupState: this.state.groupState,
            groupZipcode: this.state.groupZipcode,
        }
        axios('/api/usergroup/' + this.state.groupID, {
            method: 'POST',
            data: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': this.token
            }
        }).then(response => {
            if (response.status >= 400) {
                throw new Error(response.statusText);
            }

            let selected = JSON.parse(sessionStorage.getItem('selectedEmployer'));
            if (selected) {
               selected = {value: selected.value, label: this.state.groupName, memberType: selected.memberType}
               console.log(selected)
                sessionStorage.setItem('selectedEmployer', JSON.stringify(selected));             
            }

            this.setState({
                groupModel: false
            });
            this.props.history.goBack();
        }).catch(err => {
            this.setState({ error: err.message });
        });
    }


    openDeleteTraineeDialog = (tag) => {
        this.setState({ traineeToDelete: tag });
        this.handleDeleteTraineeDialogOpen();
    }


    onRemoveTrainee = (event) => {
       // get the trainee record id
        this.handleDeleteTraineeDialogClose();
        let traineeID = this.state.traineeToDelete;
        console.log(traineeID);
        console.log(this.state.groupID);
        console.log(this.username);
        this.setState({ traineeToDelete: '' });
        let newCredit = this.state.credit + classCredit;

        let token = sessionStorage.getItem('accessToken');
        var data = {
            employerID: this.state.groupID,
            credit: newCredit,
            byUsername: this.username
        }
        let url = '/api/employerTraining/' + traineeID;
        axios(url, {
            method: 'DELETE',
            data: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then(response => {
            if (response.status >= 400) {
                throw new Error(response.statusText);
            }
            let url = '/api/employerTraining/' + this.state.groupID;
            axios(url, {
                method: 'GET'
            }).then(res => res.data)
                .then(result => {
                    console.log(result);
                    this.setState({
                        trainees: result.trainees,
                        credit: newCredit
                    });
                }).catch(error => {
                    this.setState({ 
                        error: error.message 
                    });
                });
        }).catch(err => {
            console.log(err);
            this.setState({                         
                error: err.message 
            });
        });
    }


    // this function is called in manage trainees, if there is no Users? Is this the same as onPurchaseCredit?
    onAssignCredit = () => {
        let newCredit = this.state.credit - classCredit;
        let data = {
            UserGroupID: this.state.groupID,
            EmployeeFirstName: this.state.firstName,
            EmployeeLastName: this.state.lastName,
            EmployeeDOB: this.state.dob,
            SupervisorLastName: this.state.supervisorLastName,
            AvailableCredit: classCredit,
            EmployeeUserID: null,
            LastModifiedBy: this.username,
            credit: newCredit,
        }
        axios('/api/employerTraining/', {
            method: 'POST',
            data: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (response.status !== 200) {
                throw new Error(response.statusText);
            }
            let url = '/api/employerTraining/' + this.state.groupID;
            axios(url, {
                method: 'GET'
            }).then(res => res.data)
                .then(result => {
                    console.log(result);
                    this.setState({
                        trainees: result.trainees,
                        credit: newCredit
                    });
                }).catch(error => {
                    throw error;
                });
        }).catch(err => {
            this.setState({ error: err.message });
        });
    }

    // called when state change, leads to render ipay form
    onPurchaseCredit = (event) => {
        this.props.history.push('/dashboard/employer/' + this.props.match.params.id + '/addCredit',{
            credit: this.state.credit
        })
    }

    onTrainingInfo = (id) => {
        let currentRow = this.state.trainees.find(e => e.id === id);

        axios.get('/api/userTraining/' + currentRow.trainingId).then((res) => {
            let userTraining = res.data.training;
            console.log("userTraining :");
            console.log(userTraining);
            this.props.history.push('/dashboard/trainingHistory/details', { 
                trainingId: currentRow.trainingId, 
                username: currentRow.employeeUserID, 
                courseID: userTraining.courseId, 
                courseLabel: userTraining.courseLabel,
                courseType: userTraining.type,
                restricted: true // employer has restricted view on trainee's training detail
            });
        }).catch(error => {
            this.setState({ error: error.message });
        });
    }

    hideError = () => {
        this.setState({ error: '' })
    }

    componentDidMount() {

        console.log("id:" + this.props.match.params.id);

        // if in the Edit mini tab, grab the list of states from API and update groupStates
        if (!this.manageTrainee && !this.editContacts && !this.state.purchasingCredit) {
            this.setState({ loading: true })

            console.log("GRAB STATES CALLED")
            axios.get('/api/stateCounty/states', {
            }).then((res) => {
                let states = res.data.states;
                this.setState({ groupStates: states });
                this.setState({ loading: false })

            }).catch(error => {
                this.setState({ error: error.message });
                this.setState({ loading: false })

            });
        }

        if (this.props.match.params.id !== undefined) {
            this.setState({ loading: true })

            console.log("In if id match")
            axios.get('/api/userGroup/' + this.props.match.params.id, {
            }).then((res) => {
                let group = res.data;
                console.log(group);
                this.setState({
                    groupName: group.usergroup.name,
                    groupType: group.usergroup.type,
                    groupContact: group.usergroup.contact,
                    groupAddress: group.location.STREET,
                    groupCity: group.location.CITY,
                    groupState: group.location.STATECODE,
                    groupZipcode: group.location.ZIPCODE,
                    locID: group.location.ID,
                    credit: group.usergroup.credit,
                });
                this.setState({ loading: false })

            }).catch(error => {
                this.setState({ error: error.message });
                this.setState({ loading: false })

            });
        } else {
            console.log("In else")
            this.setState({
                id: undefined,
                name: ''
            });
        }

        if (this.editContacts) {
            this.setState({ loading: true })

            console.log("In edit contacts")
            let url = '/api/groupuser/users/' + this.state.groupID;
            axios(url, {
                method: 'GET'
            }).then(res => res.data)
                .then(result => {
                    let contacts = result.users.filter((u) => u.memberType === 'Owner');
                    this.setState({
                        contacts: contacts
                    });
                    this.setState({ loading: false })

                }).catch(error => {
                    this.setState({ error: error.message });
                    this.setState({ loading: false })

                });
        }

        if (this.manageTrainee) {
            this.setState({ loading: true })

            console.log("In manageTrainee")
            let url = '/api/employerTraining/' + this.state.groupID;
            axios(url, {
                method: 'GET'
            }).then(res => res.data)
                .then(result => {
                    console.log(result);
                    this.setState({
                        trainees: result.trainees,
                        loading: false
                    });
                }).catch(error => {
                    this.setState({ error: error.message });
                });
        }
    }

    componentWillUnmount() {
        // if (ValidatorForm.hasValidationRule('isAtLeast1')) {
        //     ValidatorForm.removeValidationRule('isAtLeast1');
        // }


        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    renderTrainees(classes) {

        if (this.state.error) {
            return <div>
                <br />
                <Alert severity="error" onClose={this.hideError}>{this.state.error}</Alert>
                <br />
            </div>
        }

        if (this.state.error !== null) return <Error />;

        let enhancedData = [];
        enhancedData = this.state.trainees.map((arrayItem) => {
            let item = JSON.parse(JSON.stringify(arrayItem));
            item.employeeName = item.employeeFirstName + ' ' + item.employeeLastName;
            item.assignBy = item.last_name? item.first_name + ' ' + item.last_name : '';
            item.actionsDisabled = {
                delete: item.status !== "Assigned",
                training: item.employeeUserID === null  || item.trainingId === null
            }
            return item;
        });

        const headCells = [
            { id: 'Action', label: 'Action', centered: false},
            { id: 'lastModified', label: 'Assign Date', centered: false, sortable: true },
            { id: 'assignBy', label: 'Assign By', centered: false, sortable: true },
            { id: 'employeeName', label: 'Employee Name', centered: false,sortable: true},
            { id: 'employeeDOB', label: 'Employee DOB', centered: false,sortable: true },
            { id: 'supervisorLastName', label: 'Supervisor Last Name', centered: false ,sortable: true},
            { id: 'employeeUserID', label: 'Employee Username', centered: false,sortable: true },
            { id: 'status', label: 'Status', centered: true, sortable: true },
            { id: 'certID', label: 'Certificate ID', centered: true, sortable: true}
        ];

         const bodyCells = [
            { id: 'lastModified', centered: false},
            { id: 'assignBy', centered: false},
            { id: 'employeeName', centered: false },
            { id: 'employeeDOB',  centered: false },
            { id: 'supervisorLastName', centered: false },
            { id: 'employeeUserID', centered: false, hyperlink: this.onTrainingInfo },
            { id: 'status', centered: true },
            { id: 'certID', centered: true }
        ];

        const actionButtons = [
            { icon: "delete", action: this.openDeleteTraineeDialog, delete: true },
            // { icon: "training", label: "Training", action: this.onTrainingInfo}
        ];

        const defaultSortKey = 'lastModified';
        const editDelete = false;

        return (
            <Fragment>
                <PageHeader
                    title={"Manage Employee Training for " + this.state.groupName}
                    cancel={this.props.history.goBack}
                    actionButtons={[{ label: "Add Credit to Purchase Training/Test", action: this.onPurchaseCredit }]}
                />
                <Alert severity="info">You have ${this.state.credit} credit. Each employee online training/test costs $15.</Alert>
                {this.state.credit === 0 &&
                    <Alert severity="warning">Please purchase credit before adding trainee.</Alert>

                }

                <ValidatorForm
                    noValidate
                    onSubmit={this.onAssignCredit}
                >

                    {this.state.info &&
                        <div>
                            <Alert severity="error" onClose={this.hideInfo}>{this.state.info}</Alert>
                            <br />
                        </div>
                    }
                    <br/>
                    <p>Assign $15 online training/test credit to an employee:</p>
                    <Grid container spacing={3}>

                        <Grid item xs={5}>

                            <TextValidator
                                label="First Name"
                                type="text"
                                name='firstName'
                                value={this.state.firstName}
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                validators={['required']}
                                errorMessages={['First Name is required', 'Please enter a valid name']}
                                fullWidth
                                required
                            />
                        </Grid>

                        <Grid item xs={5}>
                            <TextValidator
                                label="Last Name"
                                type="text"
                                name='lastName'
                                value={this.state.lastName}
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                validators={['required']}
                                errorMessages={['Last Name is required', 'Please enter a valid name']}
                                fullWidth
                                required
                            />
                        </Grid>

                        <Grid item xs={5}>
                            <TextValidator
                                label="Supervisor Last Name"
                                type="text"
                                name='supervisorLastName'
                                value={this.state.supervisorLastName}
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                validators={['required']}
                                errorMessages={['Supervisor Last Name is required', 'Please enter a valid name']}
                                fullWidth
                                required
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <TextValidator
                                id="date"
                                label="Date of Birth (optional)"
                                type="date"
                                name='dob'
                                value={this.state.dob || ""}
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth

                            />
                        </Grid>

                        <Grid item xs={2} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                            <Button variant="contained" color="primary" className={[].join(' ')} type="submit" >Assign Credit</Button>
                        </Grid>
                    </Grid>

                    <br /><br />

                    <SortedTable
                                data={enhancedData}
                                headCells={headCells}
                                bodyCells={bodyCells}
                                defaultSortKey={defaultSortKey}
                                cellKey={"id"}
                                editDelete={editDelete}
                                actionButtons={actionButtons}
                                actions={true}
                            />  

                    <DeleteDialog
                        open={this.state.isDeleteTraineeDialogOpen}
                        onClose={this.handleDeleteTraineeDialogClose}
                        onDelete={this.onRemoveTrainee}
                    />
                </ValidatorForm>
            </Fragment>
        );
    }

    onCheckUsername  = (event) => {
        if (this.state.groupName === undefined || this.state.groupName.length <1) {
            this.setState({ 
                error: "Group Name cannot be empty",
                groupNameChecked : false
            });
            return;
        }

        axios('/api/userGroup/exist/' + this.state.groupType + '/' +this.state.groupName, {
            method: 'GET'
        })
        .then(res => res.data)
        .then(result => {
            if (result.exist) {
                // username is already been used, set error message
              //  console.log('here we found');
                this.setState({ 
                    groupNameChecked : false,
                    error: this.state.groupName + " has already been used. Please pick a different Group Name."
                });
            }
            else {
              //  console.log('here we didnt found');
                this.setState({ groupNameChecked: true});
            }
                
        }).catch(error => {
            this.setError(error);
        });
    }

    
    renderCreateEdit(classes) {
        return (
            <ValidatorForm
                noValidate
                onSubmit={this.state.groupID === undefined ? this.onAdd : this.onUpdate}
            >
                <Fragment>
                    <PageHeader
                        title={"Employer"}
                        cancel={this.props.history.goBack}
                        actionButtons={[{ label: this.state.groupID === undefined ? "Add" : "Update", disabled: !this.state.groupNameChecked &&  this.state.groupID === undefined }]}
                        errorDetails={{
                            feedback: this.state.error,
                            dismiss: this.hideError
                        }}
                    />
                    <Grid container  justifyContent="space-around"  alignItems="center">

                        <Grid item xs={12} md={6} style={{ textAlign: "left", alignSelf: "flex-start" }}>
                            <p>Employer Name Guidelines:</p>
                            <ul>
                                <li>No more than 50 characters</li>
                                <li>Put company name first </li>
                                <li>If more than one, add a descriptor such as city, street, manager, or branch ID </li>
                                <li>Make it easy for your employees to remember </li>
                            </ul>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>

                        {
                            this.state.groupID === undefined 
                            ?
                            <>
                                 <Grid item xs={12} sm={6}>
                                        <TextValidator
                                            label="Employer Name"
                                            type="text"
                                            name='groupName'
                                            value={this.state.groupName}
                                            className={[classes.textField].join(' ')}
                                            onChange={this.handleChange}
                                            InputProps={{
                                                endAdornment: (
                                                <InputAdornment position="end">
                                                {this.state.groupNameChecked ? <CheckIcon /> : "" }
                                                </InputAdornment>
                                                )
                                        }}
                                validators={['required']}
                                errorMessages={['Name is required']}
                                fullWidth
                                required
                            />
                            </Grid>

                            <Grid item xs={2}>
                                <Box display="flex" mt={2.5}>
                                    <Button variant="outlined"  onClick={this.onCheckUsername} size="small" color="primary" className={[].join(' ')} > { 'Check' } </Button>
                                </Box>
                            </Grid>
                            
                            </>
                            :
                            <>
                                <Grid item xs={12} sm={5}>
                                        <TextField
                                            label="Employer Name"
                                            type="text"
                                            name='groupName'
                                            value={this.state.groupName}
                                            className={[classes.textField].join(' ')}
                                            onChange={this.handleChange}
                                            InputProps={{
                                                endAdornment: (
                                                <InputAdornment position="end">
                                                {this.state.groupNameChecked ? <CheckIcon /> : "" }
                                                </InputAdornment>
                                                )
                                            }}
                                            fullWidth

                                    />
                                </Grid>
                                <Grid item xs={1}>
                                    <Box display="flex" mt={2.5}>
                                        <Button variant="outlined"  onClick={this.onCheckUsername} size="small" color="primary" className={[].join(' ')} > { 'Check' } </Button>
                                    </Box>
                                </Grid>
                            </>
                        }

                        <Grid item xs={12} sm={6}>
                            <TextValidator
                                id="standard-basic"
                                label="Employer Address"
                                type="text"
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.groupAddress}
                                name='groupAddress'
                                validators={['required']}
                                errorMessages={['Address is required']}
                                fullWidth
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextValidator
                                id="standard-basic"
                                label="City"
                                type="text"
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.groupCity}
                                name='groupCity'
                                validators={['required']}
                                errorMessages={['City is required']}
                                fullWidth
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <SelectValidator
                                id="groupState"
                                name="groupState"
                                style={{ minWidth: '5ch' }}
                                className={[classes.textField].join(' ')}
                                value={this.state.groupState}
                                onChange={this.handleSelectChange}
                                select
                                validators={['required']}
                                errorMessages={['State is required']}
                                required
                                fullWidth
                                label="State"
                            >
                                {this.state.groupStates.map((state) => (
                                    <MenuItem key={state} value={state}>
                                        {state}
                                    </MenuItem>
                                ))}
                            </SelectValidator>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextValidator
                                id="standard-basic"
                                label="Zipcode"
                                type="number"
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.groupZipcode}
                                name='groupZipcode'
                                validators={['required']}
                                errorMessages={['Zipcode is required']}
                                fullWidth
                                required
                            />
                        </Grid>
                    </Grid>
                </Fragment>
            </ValidatorForm>
        );
    }

    renderOptions(classes) {
        console.log(this.editContacts);
        console.log(this.manageTrainee);
         if (this.manageTrainee) {
            // if (this.state.purchasingCredit) {
            //     return this.renderIpayForm(classes);
            // }
            return this.renderTrainees(classes);
        }
        //all else
        else {
            return this.renderCreateEdit(classes);
        }
    }
    render() {
        const { classes } = this.props;

        return (
            this.renderOptions(classes)
        );
    }
}

export default withStyles(styles, { withTheme: true })(Employer);
